export const logoPrincipal = "/externo-portal-backend/configuracoes/frontend/clientes/logo/header-atendimento.png";
export const logoSecundaria = "/externo-portal-backend/configuracoes/frontend/clientes/logo/header-portal.png";
export const imgHome = "/externo-portal-backend/configuracoes/frontend/clientes/home/home-portal-image.jpg"
